// Format date to DD.MM.YYYY
export const formatDate = (date) => {
  if (!date) return '';

  // Normalize to YYYY-MM-DD string without timezone impact
  let iso = '';

  if (date instanceof Date) {
    const y = date.getUTCFullYear();
    const m = date.getUTCMonth() + 1;
    const d = date.getUTCDate();
    const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
    iso = `${y}-${pad(m)}-${pad(d)}`;
  } else if (typeof date === 'string') {
    const match = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      iso = `${match[1]}-${match[2]}-${match[3]}`;
    }
  }

  if (!iso) return '';

  const [year, month, day] = iso.split('-');
  return `${day}.${month}.${year}`;
};

// Format time to HH:MM
export const formatTime = (time) => {
  if (!time) return '';

  // If time is in HH:MM:SS format, extract HH:MM
  if (typeof time === 'string') {
    if (time.length > 5 && time.includes(':')) {
      return time.substring(0, 5);
    }
  }

  return time;
};

// Combine date and time to DD.MM.YYYY HH:MM
export const formatDateTime = (date, time) => {
  if (!date) return '';

  const formattedDate = formatDate(date);
  const formattedTime = formatTime(time);

  if (!formattedTime) return formattedDate;

  return `${formattedDate} ${formattedTime}`;
};

// Format partial date composed of year/month/day to the most precise known representation
export const formatPartialDate = (year, month, day) => {
  const y = year ? Number(year) : null;
  const m = month ? Number(month) : null;
  const d = day ? Number(day) : null;

  if (!y) return '';

  const pad = (n) => (n < 10 ? `0${n}` : `${n}`);

  if (!m) return `${y}`;
  if (!d) return `${pad(m)}.${y}`;
  return `${pad(d)}.${pad(m)}.${y}`;
};

// Format amount with proper decimal places based on currency minor units
export const formatAmount = (amount, minorUnits = 2) => {
  if (amount === null || amount === undefined) return '';
  return Number(amount).toFixed(minorUnits);
};

// Format flight time range: DD.MM.YYYY HH:MM - HH:MM (+N)
export const formatFlightTimeRange = (depDate, depTime, arrDate, arrTime) => {
  if (!depDate) return '';

  const formattedDepDate = formatDate(depDate);
  const formattedDepTime = formatTime(depTime);
  const formattedArrTime = formatTime(arrTime);

  // If no departure time, return just the date
  if (!formattedDepTime) {
    return formattedDepDate;
  }

  // Build result with departure
  let result = `${formattedDepDate} ${formattedDepTime}`;

  // Add arrival time if available
  if (formattedArrTime) {
    result += ` → ${formattedArrTime}`;

    // Calculate day difference if arrival date exists and differs from departure
    if (arrDate) {
      const depDateStr = depDate.includes('T') ? depDate.split('T')[0] : depDate;
      const arrDateStr = arrDate.includes('T') ? arrDate.split('T')[0] : arrDate;

      if (depDateStr !== arrDateStr) {
        const dep = new Date(depDateStr);
        const arr = new Date(arrDateStr);
        const diffDays = Math.round((arr - dep) / (1000 * 60 * 60 * 24));
        if (diffDays > 0) {
          result += ` (+${diffDays})`;
        }
      }
    }
  }

  return result;
};
